import type { schemaType as CottageListData } from '~~/shared/api/rurality/v3/search/cottages/schema'
import type { HomeToGoLocationData } from '../entities/types'

export function extractHomeToGoLocationData(
  cottagesData?: CottageListData,
): HomeToGoLocationData {
  if (!cottagesData?.destination) {
    return { name: 'España' }
  }

  const {
    type,
    name,
    parentName,
    latitude,
    longitude,
    parentLatitude,
    parentLongitude,
  } = cottagesData.destination

  const createCoordinates = (lat: number, lng: number) => ({
    lat,
    lng,
  })

  let locationName: string
  let useParentCoordinates = false
  let shouldOmitCoordinates = false

  if (cottagesData.corner) {
    locationName = parentName || name
    useParentCoordinates = false
  } else {
    switch (type) {
      case 'village':
      case 'zone':
        locationName = parentName || name
        useParentCoordinates = false
        break

      case 'province':
      case 'region':
        locationName = name
        useParentCoordinates = false
        break

      case 'country':
        locationName = name
        shouldOmitCoordinates = true
        break

      default:
        locationName = name
        useParentCoordinates = false
    }
  }

  const coordinates = shouldOmitCoordinates
    ? undefined
    : useParentCoordinates
      ? parentLatitude && parentLongitude
        ? createCoordinates(parentLatitude, parentLongitude)
        : undefined
      : latitude && longitude
        ? createCoordinates(latitude, longitude)
        : undefined

  return { name: locationName, coordinates }
}

export function extractHomeToGoLocationName(
  cottagesData?: CottageListData,
): string {
  return extractHomeToGoLocationData(cottagesData).name
}
